
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import HelloWorld from "../components/HelloWorld.vue";
    @Component({
        components: {HelloWorld}
    })
    export default class DemoTs extends Vue {
        body = 111;
        a(){
            this.body=222;
        }
    }
